
export const StorageKeys = {
    AuthRedirectUrl: 'auth-redirectUrl',
    LastOrganizationId: 'last-orgId',
    LastEventId: 'last-eventId'
};